export default {
    name: 'Login',
    data: () => {
        return {
            loading: false,
            errors: '',
            credentials: {}
        }
    },
    created() {
        this.credentials.userName = this.$route.query.userName;
    },
    computed: {
    },
    methods: {
        handleSubmit() {
            this.loading = true;

            this.$store.dispatch('auth/authRequest', this.credentials)
                .then((result) => {
                    // get user information
                    this.$store.dispatch('user/userRequest')
                        .catch((err) => {
                            this.$router.push({ name: 'Login' });
                        });

                    if (this.$route.query.returnUrl) {
                        this.$router.push({ path: this.$route.query.returnUrl });
                    }
                    else {
                        this.$router.push('/crm');
                    }
                })
                .catch((err) => {
                    // if (err == "undefined")
                    this.errors = 'Nume utilizator sau parolă incorecte!';
                })
                .then(() => {
                    this.loading = false;
                });
        },
        forgotPasswordClick() {
            this.$router.push({ name: 'ForgotPassword' });
        }
    }
}
